import React from 'react';
import LegacyTutorialPage from 'views/Legacy/TutorialPage';
import LegacyCourseLayout from 'layouts/LegacyCourseLayout';
import WithLayout from 'WithLayout';
import PropTypes from 'prop-types';
import propTypes from 'helpers/propTypes';

const LegacyTutorialPagePage = ({pageContext}) => (
  <WithLayout
    component={LegacyTutorialPage}
    layout={LegacyCourseLayout}
    pageContext={pageContext}
  />
);

LegacyTutorialPagePage.propTypes = {
  pageContext: PropTypes.shape({
    tutorial: propTypes.tutorial,
  }).isRequired,
};

export default LegacyTutorialPagePage;
